<template>
    <div class='kLineChart'>
        <div class='header'>
            <h3>K线图</h3>
            <el-autocomplete
                v-model="code"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                @select="handleSelect"
            ></el-autocomplete>
        </div>
        <div class='content' ref='echars'>

        </div>
    </div>
</template>

<script >
import { getAListOfStocksApi, getMinuteDataApi } from '@/utils/api';

    export default{
        data(){
            return {
                code:'',
                myChart:''
            }
        },
        mounted() {
            this.myChart = this.$echarts.init(this.$refs.echars)
            window.addEventListener('resize', this.charsResize);
            this.code = '平安银行'
            this.handleSelect({
                code:'000001'
            })
        },
        destroyed() {
          window.removeEventListener('resize', this.charsResize)
        },
        methods:{
            //改变echars高度宽度
            charsResize(){
                if(this.myChart){
                    this.myChart.resize();
                }
            },
            querySearchAsync(queryString, cb){
                if(queryString==='') return
                getAListOfStocksApi(queryString).then(res=>{
                    const data = res.data.map(item=>{
                        const obj = {}
                        obj.value = item.name
                        obj.code = item.code
                        return obj
                    })
                    cb(data);
                })
            },
            handleSelect(item) {
                const chars = this.myChart
                const upColor ='#ec0000';
                const downColor =  '#00da3c';
                const  splitData = (rawData)=> {
                    let categoryData = [];
                    let values = [];
                    let volumes = [];
                    for (let i = 0; i < rawData.length; i++) {
                        categoryData.push(rawData[i].splice(0, 1)[0]);
                        values.push(rawData[i]);
                        volumes.push([i, rawData[i][4], rawData[i][0] > rawData[i][1] ? 1 : -1]);
                    }
                    return {
                        categoryData: categoryData,
                        values: values,
                        volumes: volumes
                    };
                }
                const calculateMA = (dayCount, data)=> {
                    var result = [];
                    for (var i = 0, len = data.values.length; i < len; i++) {
                        if (i < dayCount) {
                            result.push('-');
                            continue;
                        }
                        var sum = 0;
                        for (var j = 0; j < dayCount; j++) {
                            sum += data.values[i - j][1];
                        }
                        result.push(+(sum / dayCount).toFixed(3));
                    }
                    return result;
                }
                getMinuteDataApi(item.code).then(res=>{
                    const data = res.data.map((item=>[item.time.slice(11,-3),Number(item.open),Number(item.close),Number(item.low),Number(item.high),Number(item.volume)]))
                    const data2 = splitData(data.map(item=>[...item]));
                    chars.setOption(
                        {
                            animation: false,
                            legend: {
                                bottom: 10,
                                left: 'center',
                                data: ['时K', 'MA5', 'MA10', 'MA20', 'MA30']
                            },
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross'
                                },
                                borderWidth: 1,
                                borderColor: '#ccc',
                                padding: 10,
                                textStyle: {
                                    color: '#000'
                                },
                                position: function (pos, params, el, elRect, size) {
                                    const obj = {
                                        top: 10
                                    };
                                    obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                                    return obj;
                                }
                                // extraCssText: 'width: 170px'
                            },
                            axisPointer: {
                                link: [
                                    {
                                        xAxisIndex: 'all'
                                    }
                                ],
                                label: {
                                    backgroundColor: '#777'
                                }
                            },
                            toolbox: {
                                x:10,
                            },
                            brush: {
                                xAxisIndex: 'all',
                                brushLink: 'all',
                                outOfBrush: {
                                    colorAlpha: 0.1
                                }
                            },
                            visualMap: {
                                show: false,
                                seriesIndex: 5,
                                dimension: 2,
                                pieces: [
                                    {
                                        value: 1,
                                        color: downColor
                                    },
                                    {
                                        value: -1,
                                        color: upColor
                                    }
                                ]
                            },
                            grid: [
                                {
                                    left: '5%',
                                    right: '4%',
                                    height: '50%'
                                },
                                {
                                    left: '5%',
                                    right: '4%',
                                    top: '63%',
                                    height: '16%'
                                }
                            ],
                            xAxis: [
                                {
                                    type: 'category',
                                    data: data2.categoryData,
                                    boundaryGap: false,
                                    axisLine: { onZero: false },
                                    splitLine: { show: false },
                                    min: 'dataMin',
                                    max: 'dataMax',
                                    axisPointer: {
                                        z: 100
                                    }
                                },
                                {
                                    type: 'category',
                                    gridIndex: 1,
                                    data: data2.categoryData,
                                    boundaryGap: false,
                                    axisLine: { onZero: false },
                                    axisTick: { show: false },
                                    splitLine: { show: false },
                                    axisLabel: { show: false },
                                    min: 'dataMin',
                                    max: 'dataMax'
                                }
                            ],
                            yAxis: [
                                {
                                    scale: true,
                                    splitArea: {
                                        show: true
                                    }
                                },
                                {
                                    scale: true,
                                    gridIndex: 1,
                                    splitNumber: 2,
                                    axisLabel: { show: false },
                                    axisLine: { show: false },
                                    axisTick: { show: false },
                                    splitLine: { show: false }
                                }
                            ],
                            dataZoom: [
                                {
                                    type: 'inside',
                                    xAxisIndex: [0, 1],
                                    start: 60,
                                    end: 100
                                },
                                {
                                    show: true,
                                    xAxisIndex: [0, 1],
                                    type: 'slider',
                                    top: '85%',
                                    start: 90,
                                    end: 100
                                }
                            ],
                            series: [
                                {
                                    name: '时K',
                                    type: 'candlestick',
                                    data: data2.values,
                                    itemStyle: {
                                        color: upColor,
                                        color0: downColor,
                                        borderColor: undefined,
                                        borderColor0: undefined
                                    },
                                    tooltip: {
                                        formatter: function (param) {
                                            param = param[0];
                                            return [
                                                'Date: ' + param.name + '<hr size=1 style="margin: 3px 0">',
                                                'Open: ' + param.data[0] + '<br/>',
                                                'Close: ' + param.data[1] + '<br/>',
                                                'Lowest: ' + param.data[2] + '<br/>',
                                                'Highest: ' + param.data[3] + '<br/>'
                                            ].join('');
                                        }
                                    }
                                },
                                {
                                    name: 'MA5',
                                    type: 'line',
                                    data: calculateMA(5, data2),
                                    smooth: true,
                                    lineStyle: {
                                        opacity: 0.5
                                    }
                                },
                                {
                                    name: 'MA10',
                                    type: 'line',
                                    data: calculateMA(10, data2),
                                    smooth: true,
                                    lineStyle: {
                                        opacity: 0.5
                                    }
                                },
                                {
                                    name: 'MA20',
                                    type: 'line',
                                    data: calculateMA(20, data2),
                                    smooth: true,
                                    lineStyle: {
                                        opacity: 0.5
                                    }
                                },
                                {
                                    name: 'MA30',
                                    type: 'line',
                                    data: calculateMA(30, data2),
                                    smooth: true,
                                    lineStyle: {
                                        opacity: 0.5
                                    }
                                },
                                {
                                    name: 'Volume',
                                    type: 'bar',
                                    xAxisIndex: 1,
                                    yAxisIndex: 1,
                                    data: data2.volumes
                                }
                            ]
                        }
                    )
                })
            }
        }
    }
</script>

<style scoped lang='scss'>
    .kLineChart{
        display: flex;
        flex-direction: column;
        height: 100%;
        .header{
            flex-shrink: 0;
            height: 56px;
            padding: 0 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3{
                font-size: 18px;
                font-family: Microsoft YaHei,serif;
                font-weight: bold;
                color: #3C3C3C;
            }
            .el-autocomplete{
                width:280px;
            }
            border-bottom: 2px solid #ebe8e8;
        }
        .content{
            flex: 1;
        }
    }
</style>
